function Members() {
  return (
    <div className='container'>
      <hr className='sectionSeparator' />
      <h2 className='centered headerRad sectionHeader'>Η μπάντα</h2>
      <h5 className='centered'>
        Δημήτρης Βαλιώτης ~ κρουστά
        <br />
        Λένα Καραγιαννίδου ~ ακορντεόν
        <br />
        Αλέξανδρος Μακρής ~ κιθάρα
        <br />
        Δημήτρης Χαριτάτος ~ φωνή, μπάσο
        <br />
        Δημήτρης Ψαθάς ~ φωνή, βιολί
      </h5>
      <hr className='sectionSeparator' />
    </div>
  );
}

export default Members;
